// Local translations
export const T = {
  en_GB: {
    showSigningQr: "Show signing QR code",
    copy: "Copy",
    digitalSignatures: "Digital Signatures",
    signatureDescription: "Request digital signatures for all generated PDFs",
    signatureDescriptionWithCount: (count: number) =>
      `Request digital signatures for all ${count} generated PDF${count > 1 ? "s" : ""}`,
    noPdfsToSign: "No PDFs available to sign. Please generate PDFs first.",
    chooseSignatureMethod: "Choose Signature Method:",
    selectHowToSign: "Select how the client should sign the documents",
    noSignatureMethod: "No signing method is available for this flow.",
    eidSignature: "eID Signature",
    eidDescription: "Secure digital signature using national eID (BankID, MitID, etc.)",
    legallyBinding: "Legally binding",
    identityVerified: "Identity verified",
    bestForNordics: "Best for: NO, SE, DK",
    createEidRequest: "Create eID Request",
    simpleSignature: "Simple Signature",
    simpleDescription:
      "Draw signature with mouse/finger. Suitable for countries without eID support.",
    quickEasy: "Quick & easy",
    recordsEvidence: "Records evidence",
    bestForOthers: "Best for: Other countries",
    createSimpleRequest: "Create Simple Request",
    signatureRequest: "Signature Request",
    shareLink: "Share this link with the client to sign the documents",
    checkStatus: "Check Status",
    signingLink: "Signing Link",
    simpleSignatureLabel: "Simple signature",
    eidSignatureLabel: "eID signature",
    expires: "Expires",
    email: "Email",
    sms: "SMS",
    emailAddress: "Email Address",
    save: "Save",
    send: "Send",
    enterEmailToSend: "Enter an email address to send the signing invitation",
    saveEmailFirst: "Save the email address before sending",
    mobilePhone: "Mobile Phone",
    enterPhoneToSend: "Enter a phone number to send the signing invitation",
    savePhoneFirst: "Save the phone number before sending",
    documentsToSign: "Documents to be signed:",
    signedDocuments: "Signed Documents",
    documentsSignedOn: "Documents signed on",
    signer: "Signer:",
    method: "Method:",
    verifiedVia: "Verified via:",
    signature: "Signature:",
    document: "Document",
    signedDate: "Signed Date",
    actions: "Actions",
    download: "Download",
    signatureHistory: "Signature History",
    documents: (count: number) => `document${count > 1 ? "er" : ""}`,
    created: "Created",
    failedToCreateOrder: "Failed to create signature order",
    eidLinkCreated: "eID signature link created successfully!",
    simpleLinkCreated: "Simple signature link created successfully!",
    linkCopied: "Signature link copied to clipboard!",
    failedToUpdateClient: "Failed to update client information",
    clientInfoUpdated: "Saved",
    enterEmail: "Please enter an email address",
    failedToSendEmail: "Failed to send email",
    inviteSentTo: (recipient: string) => `Signing invite sent to ${recipient}!`,
    enterPhone: "Please enter a mobile phone number",
    failedToSendSms: "Failed to send SMS",
    failedToGetDownload: "Failed to get download URL",
    failedToDownload: "Failed to download signed PDF",
    deleteSignatureRequest: "Delete Signature Request",
    deleteConfirmation: "Are you sure you want to delete this signature request?",
    delete: "Delete",
    cancel: "Cancel",
    failedToDelete: "Failed to delete signature request",
    deletedSuccess: "Signature request deleted successfully!",
    failedToRefresh: "Failed to refresh signature status",
    documentSigned: "Document has been signed!",
    statusUpdated: (status: string) => `Status updated: ${status}`,
    signed: "Signed",
    inProgress: "In Progress",
    pending: "Pending",
    expired: "Expired",
    cancelled: "Cancelled",
    failed: "Failed",
    signingLinkTitle: "Signing Link",
  },
  nb_NO: {
    showSigningQr: "Vis QR-kode for signering",
    copy: "Kopier",
    digitalSignatures: "Digitale signaturer",
    signatureDescription: "Be om digitale signaturer for alle genererte PDF-er",
    signatureDescriptionWithCount: (count: number) =>
      `Be om digitale signaturer for alle ${count} genererte PDF-${count > 1 ? "s" : ""}`,
    noPdfsToSign: "Ingen PDF-er tilgjengelig for signering. Vennligst generer PDF-er først.",
    chooseSignatureMethod: "Velg signeringsmetode:",
    selectHowToSign: "Velg hvordan kunden skal signere dokumentene",
    noSignatureMethod: "Ingen signeringsmetode er tilgjengelig for denne flyten.",
    eidSignature: "eID-signatur",
    eidDescription: "Sikker digital signatur med nasjonal eID (BankID, MitID, osv.)",
    legallyBinding: "Juridisk bindende",
    identityVerified: "Identitet verifisert",
    bestForNordics: "Best for: NO, SE, DK",
    createEidRequest: "Opprett eID-forespørsel",
    simpleSignature: "Enkel signatur",
    simpleDescription: "Tegn signatur med mus/finger. Egnet for land uten eID-støtte.",
    quickEasy: "Raskt og enkelt",
    recordsEvidence: "Registrerer bevis",
    bestForOthers: "Best for: Andre land",
    createSimpleRequest: "Opprett enkel forespørsel",
    signatureRequest: "Signeringsforespørsel",
    shareLink: "Del denne lenken med kunden for å signere dokumentene",
    checkStatus: "Sjekk status",
    signingLink: "Signeringslenke",
    simpleSignatureLabel: "Enkel signatur",
    eidSignatureLabel: "eID-signatur",
    expires: "Utløper",
    email: "E-post",
    sms: "SMS",
    emailAddress: "E-postadresse",
    save: "Lagre",
    send: "Send",
    enterEmailToSend: "Skriv inn en e-postadresse for å sende signeringsinvitasjonen",
    saveEmailFirst: "Lagre e-postadressen før du sender",
    mobilePhone: "Mobiltelefon",
    enterPhoneToSend: "Skriv inn et telefonnummer for å sende signeringsinvitasjonen",
    savePhoneFirst: "Lagre telefonnummeret før du sender",
    documentsToSign: "Dokumenter som skal signeres:",
    signedDocuments: "Signerte dokumenter",
    documentsSignedOn: "Dokumenter signert den",
    signer: "Signerer:",
    method: "Metode:",
    verifiedVia: "Verifisert via:",
    signature: "Signatur:",
    document: "Dokument",
    signedDate: "Signeringsdato",
    actions: "Handlinger",
    download: "Last ned",
    signatureHistory: "Signeringshistorikk",
    documents: (count: number) => `dokument${count > 1 ? "er" : ""}`,
    created: "Opprettet",
    failedToCreateOrder: "Kunne ikke opprette signeringsforespørsel",
    eidLinkCreated: "eID-signeringslenke opprettet!",
    simpleLinkCreated: "Enkel signeringslenke opprettet!",
    linkCopied: "Signeringslenke kopiert til utklippstavlen!",
    failedToUpdateClient: "Kunne ikke oppdatere kundeinformasjon",
    clientInfoUpdated: "Lagret",
    enterEmail: "Vennligst skriv inn en e-postadresse",
    failedToSendEmail: "Kunne ikke sende e-post",
    inviteSentTo: (recipient: string) => `Signeringsinvitasjon sendt til ${recipient}!`,
    enterPhone: "Vennligst skriv inn et mobilnummer",
    failedToSendSms: "Kunne ikke sende SMS",
    failedToGetDownload: "Kunne ikke hente nedlastingslenke",
    failedToDownload: "Kunne ikke laste ned signert PDF",
    deleteSignatureRequest: "Slett signeringsforespørsel",
    deleteConfirmation: "Er du sikker på at du vil slette denne signeringsforespørselen?",
    delete: "Slett",
    cancel: "Avbryt",
    failedToDelete: "Kunne ikke slette signeringsforespørsel",
    deletedSuccess: "Signeringsforespørsel slettet!",
    failedToRefresh: "Kunne ikke oppdatere signeringsstatus",
    documentSigned: "Dokumentet er signert!",
    statusUpdated: (status: string) => `Status oppdatert: ${status}`,
    signed: "Signert",
    inProgress: "Pågår",
    pending: "Venter",
    expired: "Utløpt",
    cancelled: "Kansellert",
    failed: "Feilet",
    signingLinkTitle: "Signeringslenke",
  },
} as const;
